var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "#054254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18472 10.9193L13.9202 3.1119L12.8803 2.08074L6.16648 8.83853L3.08324 5.70822L2.04333 6.75779L6.18472 10.9193ZM6.18472 13L0 6.75779L3.08324 3.62748L6.18472 6.75779L12.862 0L16 3.09348L6.18472 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkOutlinedIcon);
export default __webpack_public_path__ + "static/media/checkmarkOutlinedIcon.f38574fda1adf5f3771173bd03d99bed.svg";
export { ForwardRef as ReactComponent };